// extracted by css-extract-rspack-plugin
export default {"shimmer":"_78f632d6","shimmerLoadingBackground":"_7eaf627e"};